<template>
  <el-dialog width="35%" class="dialog" :title="pageType==='add'?'新建菜单':'编辑菜单'" :visible.sync="dialogFormVisible" :close-on-click-modal="false">

    <el-form ref="ruleForm" :rules="rules" label-position="right" :model="formData" label-width="120px">

      <el-form-item
          label="上级菜单"
          prop="parentId"
        >
          <TreeSelect
            ref="treeSelectRef"
            :treeData="treeDataList"
            v-model="formData.parentId"
          >
          </TreeSelect>
        </el-form-item>

        <el-form-item label="菜单类型" prop="menuType">
          <el-radio-group v-model="formData.menuType">
            <el-radio label="M">目录</el-radio>
            <el-radio label="C">菜单</el-radio>
            <!-- <el-radio label="F">按钮</el-radio> -->
          </el-radio-group>
        </el-form-item>

        <el-form-item
          :label="formData.menuType === 'F'?'按钮名称':'菜单名称'"
          prop="menuName"
        >
          <el-input v-model="formData.menuName" placeholder="请输入菜单名称" />
        </el-form-item>

        <el-form-item
          label="显示排序"
          prop="orderNum"
        >
          <el-input v-model="formData.orderNum" placeholder="请输入显示顺序" />
        </el-form-item>

        <el-form-item
          v-if="formData.menuType !== 'F'"
          label="路由地址"
          prop="path"
        >
          <el-input v-model="formData.path" placeholder="请输入路由地址" />
        </el-form-item>

        <el-form-item
          v-if="formData.menuType !== 'F'"
          label="组件路径"
          prop="component"
        >
          <el-input v-model="formData.component" placeholder="请输入组件路径" />
        </el-form-item>

        <el-form-item v-if="formData.menuType !== 'F'" label="激活菜单" prop="activePath">
          <el-input v-model="formData.activePath" />
        </el-form-item>

        <el-form-item v-if="formData.menuType !== 'F'" label="菜单图标" prop="icon">
          <el-input v-model="formData.icon" />
        </el-form-item>

        <el-form-item v-if="formData.menuType == 'F'" label="权限字符" prop="perms">
          <el-input v-model="formData.perms" />
        </el-form-item>

        <!-- <el-form-item v-if="formData.menuType == 'C'" label="是否外链" prop="isFrame">
          <el-radio-group v-model="formData.isFrame" name="radioGroup">
              <el-radio :label="0">正常</el-radio>
              <el-radio :label="1">隐藏</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item v-if="formData.menuType !== 'F'" label="显示状态" prop="visible">
          <el-radio-group v-model="formData.visible" name="radioGroup">
            <el-radio label="0">显示</el-radio>
            <el-radio label="1">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status" name="radioGroup">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun">确 定</el-button>
    </div>

  </el-dialog>
</template>
<script>
import TreeSelect from './TreeSelect.vue'
export default {
  components: {
    TreeSelect
  },
  props: {
    treeDataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      /**
       * pageType 弹框类型 add | edit
       * dialogFormVisible 弹框状态
       * formData 表单数据
       * rules 表单规则
       */
      pageType: 'add',
      dialogFormVisible: false,
      formData: {
        parentId: '0',
        menuType: 'M',
        menuName: '',
        orderNum: '',
        path: '',
        component: '',
        activePath: '',
        icon: '',
        perms: '',
        isFrame: '',
        visible: '0',
        status: '0'
      },
      rules: {
        parentId: [
          { required: true, message: '请选择上级菜单', trigger: 'change' }
        ],
        menuType: [
          { required: true, message: '请选择菜单类型', trigger: 'change' }
        ],
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'change' }
        ],
        orderNum: [
          { required: true, message: '请输入显示顺序', trigger: 'change' }
        ],
        path: [
          { required: true, message: '请输入路由地址', trigger: 'change' }
        ],
        component: [
          { required: true, message: '请输入组件路径', trigger: 'change' }
        ]
      },
      btnLoading: false
    }
  },
  methods: {
    // 关闭弹框
    closeDialog () {
      this.dialogFormVisible = false
    },
    // 打开弹框
    openDialog (pageType = 'add', rowDataOrParentId) {
      this.dialogFormVisible = true
      this.pageType = pageType
      if (this.pageType === 'add') {
        this.formData = {
          parentId: rowDataOrParentId,
          menuType: 'M',
          visible: '0',
          status: '0'
        }
        return
      }
      if (this.pageType === 'edit') {
        this.formData = rowDataOrParentId
        console.log('=====this.formData', this.formData)
      }
    },
    // 确认提交
    submitBtnFun () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log('submit====', this.formData)
          this.btnLoading = true
          const params = Object.assign({}, { ...this.formData })
          if (this.pageType === 'add') {
            this.saveFormDataReq(params)
            return
          }

          if (this.pageType === 'edit') {
            this.editSaveFormDataReq(params)
            return
          }

        } else {
          console.log('error submit!!')
          return false;
        }
      })
    },
    // 保存和编辑数据接口
    saveFormDataReq (params) {
      const url = '/autoapp-recovery-server-auth/api/tbl-sys-menu/add'
      this.HttpService.post(url, params).then(res => {
        this.btnLoading = false
        if (res.statusCode === 200) {
          const tipMsg = '新增成功'
          this.$message.success(tipMsg)
          this.dialogFormVisible = false
          this.$emit('opera-success')
          this.$refs.ruleForm.resetFields()
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    editSaveFormDataReq (params) {
      const url = '/autoapp-recovery-server-auth/api/tbl-sys-menu/edit'
      this.HttpService.put(url, params).then(res => {
        this.btnLoading = false
        if (res.statusCode === 200) {
          const tipMsg = '修改成功'
          this.$message.success(tipMsg)
          this.dialogFormVisible = false
          this.$emit('opera-success')
          this.$refs.ruleForm.resetFields()
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 表单重置
    resetFormStatus () {
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>
<style scoped lang='scss'>
.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/components/AddMenuDialog.vue